define('LimitItemQuantity.MyAccount', [
  'OrderHistory.Details.View.LimitQty',
  'ReorderItems.List.View.LimitQty'
], function LimitItemQuantityMyAccount(
) {
  'use strict';
});
